@import "@/ui/variables.css";

.iconButtonRoot {
  --background: var(--gray-light);
  --foreground: var(--white);
  --size: 30px;

  background-color: var(--background);
  color: var(--foreground);

  text-decoration: none;

  border: none;
  border-radius: 50%;

  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--size);
  height: var(--size);
  padding: 0;
}

.iconButtonRoot:hover {
  background-color: oklch(from var(--background) calc(l + 0.05) c h);
}

.iconButtonRoot:active {
  background-color: oklch(from var(--background) calc(l + 0.1) c h);
}
